import
  styled
from 'styled-components';

import customCheckboxIcon from '../../../images/checkboxDarkIcon.svg';
import { NoMarginParagraph } from '../input/TextField.styles';

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--24px, 24px);
  width: 406px;

@media screen and (max-width:480px) {
  width: 100%;
  height: 100%;
  padding: 0px 16px;
}
`;

export const BusinessLogo = styled.div`

@media screen and (max-width:768px) {
  display: block;
}
`;


export const RememberMeContainer = styled(NoMarginParagraph)`
  display: flex;
  align-items: flex-start;
  gap: var(--12px, 12px);
  align-self: stretch;
`;

export const Label = styled.label`
  float: left;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border: solid 1px #000;
`;

export const RememberMeCheckBox = styled.input`
  position: absolute;
  opacity: 0;
  height: 20px;
  width: 20px;

  &:checked + label {
    background-image: url(${customCheckboxIcon});
    background-size: cover;
    border: none;
  }
  cursor: pointer;
`;

export const RememberMeLabel = styled.label`
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 2px;
  border: solid 1px #000;
  cursor: pointer;
  display: inline-block;
`;

export const RememberMeIcon = styled.svg`
  width: 12px;
  height: 12px;
  fill: none;
  stroke: #fff;
  stroke-width: 1.5em;
  vertical-align: middle;
  display: inline-block;
  margin: 4px;
`;

export const RememberMeText = styled.span`
  font-family: "RobotoRegular";
  font-size: 18px;
  letter-spacing: 0.96px;
  color: #2a2a2a;
`;

export const ControlContainer = styled.div``;

export const RegisterText = styled(NoMarginParagraph)`
  color: var(--Greyscale-GREY-800, #222739);
  display: block;
  font-family: "RobotoRegular";
  margin-top: 20px;
  line-height: 1.3;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;

export const RegisterHyperlink = styled.span`
  color: #bd0000;
  text-decoration: underline;
  margin-left: 4px;
  cursor: pointer;
  
  &:hover {
    color: blue;
  }
`;
